import { useEffect } from "react";
import { Outlet, useNavigation } from "react-router-dom";
import NProgress from "nprogress";

const RootLayout = () => {
  const navigation = useNavigation();

  useEffect(() => {
    if (navigation.state === "loading" || navigation.state === "submitting") {
      NProgress.start();
    } else {
      NProgress.done();
    }
  }, [navigation.state]);

  return <Outlet />;
};

export default RootLayout;
